export const COMMON_REQ = 'cris/viewCustomer/COMMON_REQ';
export const COMMON_REQ_FAIL = 'cris/viewCustomer/COMMON_REQ_FAIL';

export const LOAD_CUSTOMERS_REQ = 'cris/viewCustomer/LOAD_CUSTOMERS_REQ';

const initialState = {
	isLoading: false,
	error: null,
	customers: []
};

export default (state = initialState, action) => {
	switch (action.type) {
		case COMMON_REQ:
			return {
				...state,
				isLoading: true
			};

		case COMMON_REQ_FAIL:
			return {
				...state,
				isLoading: false,
				error: action.error
			};

		case LOAD_CUSTOMERS_REQ:
			const customers = action.payload.data.customers.map((item) => ({
				id: item.id,
				code: item.code,
				name: item.name,
				location: item.location,
				status: item.status,
				street_address: item.street_address || '',
				city	: item.city || '',
				state: item.state || '',
				zip: item.zip || '',
				is_blacklisted: (item.is_blacklisted === 1) ? 'Yes' : 'No'
			}));

			return {
				...state,
				isLoading: false,
				customers: customers
			};

		default:
			return state;
	}
}